import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from "../../environments/environment";
import { iframeAwareMsalGuard } from '@neworg-net/amsuite-core/auth';
import { workspaceManageTemplatesGuard } from '../guards/workspace-manage-templates.guard';
import { notificationTemplatesGuard } from '../guards/notification-templates.guard';
import { unsavedChangesGuard } from '../guards/unsaved-changes.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('../pages/login/login.module').then(m => m.LoginModule),
    data: {
      title: 'Login'
    },
  },
  {
    path: 'login/:userName',
    loadChildren: () => import('../pages/login/login.module').then(m => m.LoginModule),
    data: {
      title: 'Login'
    },
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    data: {
      title: 'Dashboard'
    },
    canActivate: [iframeAwareMsalGuard]
  },

  {
    path: 'managedashboard',
    loadChildren: () => import('../pages/dashboard/manage-dashboard/manage-dashboard.module').then(m => m.ManageDashboardModule),
    data: {
      title: 'Gestione dashboard'
    },
    canActivate: [iframeAwareMsalGuard]
  },

  {
    path: 'managetemplates',
    loadChildren: () => import('../pages/dashboard/manage-templates/manage-templates.module').then(m => m.ManageTemplatesModule),
    data: {
      title: 'Gestione template'
    },
    canActivate: [iframeAwareMsalGuard, workspaceManageTemplatesGuard]
  },

  {
    path: 'preferences',
    loadComponent: () => import('../pages/preferences/preferences.component').then(m => m.PreferencesComponent),
    data: {
      title: 'Preferenze'
    },
    canActivate: [iframeAwareMsalGuard]
  },

  // Testi delle email personalizzati per azienda (#2103): solo per chi il Notifier riconosce come gestore.
  {
    path: 'notifications/templates',
    loadComponent: () => import('../pages/notification-templates/notification-templates.component').then(m => m.NotificationTemplatesComponent),
    data: {
      title: 'Template notifiche'
    },
    canActivate: [iframeAwareMsalGuard, notificationTemplatesGuard]
  },

  {
    path: 'notifications/templates/:templateKey',
    loadComponent: () => import('../pages/notification-templates/editor/notification-template-editor.component').then(m => m.NotificationTemplateEditorComponent),
    data: {
      title: 'Modifica template notifica'
    },
    canActivate: [iframeAwareMsalGuard, notificationTemplatesGuard],
    canDeactivate: [unsavedChangesGuard]
  },

  {
    path: 'notifications',
    loadComponent: () => import('../pages/notifications/notifications.component').then(m => m.NotificationsComponent),
    data: {
      title: 'Notifiche'
    },
    canActivate: [iframeAwareMsalGuard]
  },

  {
    path: 'accountSettings',
    loadChildren: () => import('../pages/account-settings/account-settings.module').then(m => m.AccountSettingsModule),
    data: {
      title: 'Impostazioni account'
    },
    canActivate: [iframeAwareMsalGuard]
  },

  {
    path: 'userInfo',
    loadChildren: () => import('../pages/user-info/user-info.module').then(m => m.UserInfoModule),
    data: {
      title: 'Informazioni utente'
    },
    canActivate: [iframeAwareMsalGuard]
  },

  // Comunica deep-link: catches /comunica/{any-sub-path} for email navigation
  {
    path: 'comunica',
    children: [{
      path: '**',
      loadComponent: () => import('../pages/i-frame/i-frame.component').then(m => m.IFrameComponent),
      data: { appKey: 'comunica' }
    }],
    canActivate: [iframeAwareMsalGuard]
  },

  {
    path: ':appid/app/:id',
    loadChildren: () => import('../pages/i-frame/i-frame.module').then(m => m.IFrameModule),
    canActivate: [iframeAwareMsalGuard]
  },

  {
    path: 'app/:id',
    loadChildren: () => import('../pages/i-frame/i-frame.module').then(m => m.IFrameModule),
    canActivate: [iframeAwareMsalGuard]
  },

  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: "**", redirectTo: "dashboard" },

]

@NgModule({
  imports: [RouterModule.forRoot(routes, environment.routes.config)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
